import React from 'react';

import HighchartsReact from 'highcharts-react-official';

import { Button } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';

import { InfoOtherSource } from './components/InfoOtherSource';
import { useBarChart } from './hooks/useBarChart';

type BarChartParams = {
	allChannels: Parameters<typeof useBarChart>[0];
	otherSignatureSource?: { signaturePercent: number };
};

export function BarChart({ allChannels, otherSignatureSource }: BarChartParams): React.JSX.Element | null {
	const {
		data: { options, isShowingAllChannels, showButtons, highchartsModule },
		actions,
	} = useBarChart(allChannels);

	if (allChannels.length === 0) return null;

	return (
		<section data-qa="signature-sources-bar-chart">
			<div className="my-6">
				<HighchartsReact highcharts={highchartsModule} options={options} />
			</div>
			{!showButtons && otherSignatureSource ? (
				<InfoOtherSource signaturePercent={otherSignatureSource.signaturePercent} />
			) : null}
			{showButtons &&
				(isShowingAllChannels ? (
					<>
						{otherSignatureSource ? <InfoOtherSource signaturePercent={otherSignatureSource.signaturePercent} /> : null}
						<Button
							className="w-full"
							data-qa="signature-source-view-less"
							variant="tertiary"
							size="x-small"
							onClick={actions.showTopChannels}
						>
							<Translate value="corgi.petition.starter_dashboard_v2.petition_insights.signature_sources.view_less_button" />
						</Button>
					</>
				) : (
					<Button
						className="w-full"
						data-qa="signature-source-view-more"
						variant="tertiary"
						size="x-small"
						onClick={actions.showAllChannels}
					>
						<Translate value="corgi.petition.starter_dashboard_v2.petition_insights.signature_sources.view_more_button" />
					</Button>
				))}
		</section>
	);
}
